import type { QueryOptions } from './types.js';

/** Escape a string literal for OData $filter / keys. */
export const odataStr = (s: string) => `'${s.replace(/'/g, "''")}'`;

export function buildQuery(q?: QueryOptions): string {
  if (!q) return '';
  const p: string[] = [];
  if (q.select?.length) p.push(`$select=${q.select.join(',')}`);
  if (q.filter) p.push(`$filter=${encodeURIComponent(q.filter)}`);
  if (q.orderby) p.push(`$orderby=${encodeURIComponent(q.orderby)}`);
  if (q.expand) p.push(`$expand=${encodeURIComponent(q.expand)}`);
  if (q.top != null) p.push(`$top=${q.top}`);
  if (q.skip != null) p.push(`$skip=${q.skip}`);
  if (q.count) p.push(`$count=true`);
  return p.length ? `?${p.join('&')}` : '';
}

export type EntityKey = string | number | Record<string, string | number>;

/** Build an entity key path: Entity('V10000') | Entity(123) | Entity(DocEntry=1,LineNum=0) */
export function keyPath(entity: string, key: EntityKey): string {
  if (typeof key === 'number') return `${entity}(${key})`;
  if (typeof key === 'string') return `${entity}(${odataStr(key)})`;
  const parts = Object.entries(key).map(([k, v]) => `${k}=${typeof v === 'number' ? v : odataStr(v)}`);
  return `${entity}(${parts.join(',')})`;
}
